export enum TOGGLE_STATUS {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export enum TOGGLE_DEBUG_MODE {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export enum TOGGLE_AUTH_METHOD {
  NO_AUTHORIZATION = 'NO_AUTHORIZATION',
  API_KEY = 'API_KEY'
}

export enum REPORT_STATUS {
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED'
}

export enum OPERATION_STATUS {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED'
}

export type Status = TOGGLE_STATUS | REPORT_STATUS | OPERATION_STATUS;
